let url = window.location.host;
url = url.replace("www.", "");

export const mode = {
  isDoctor: url === process.env.VUE_APP_DOCTOR_URL,
  isAdmin: url === process.env.VUE_APP_ADMIN_URL,
  isGatekeeper: url === process.env.VUE_APP_GATEKEEPER_URL,
};
